import * as React from "react";
import Link from 'gatsby-link';
import * as companyData from "../../constants/company-data";
import * as staticUrls from "../../constants/static-urls";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import * as cookieConsentService from "../../services/cookie-consent-service";
import styled from "styled-components";

interface FooterProps {}

interface FooterState {}

class Footer extends React.Component<FooterProps,FooterState> {

  constructor(props: FooterProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
    this.onNavigateToSocialClick = this.onNavigateToSocialClick.bind(this);
    this.onCookiePreferencesClick = this.onCookiePreferencesClick.bind(this);
  }

  onComponentView() {
    googleAnalyticsService.trackEvent(GoogleAnalyticsEventType.PageFooterViewed);
  }

  onNavigateToSocialClick() {
    googleAnalyticsService.trackEvent(GoogleAnalyticsEventType.PageFooterNavigateToSocialClicked);
  }

  /** ODNOŚNIK „PREFERENCJE PLIKÓW COOKIES” => OTWIERA USTAWIENIA BANERA (Polityka cookies § 3 ust. 4) */
  onCookiePreferencesClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    cookieConsentService.showCookieSettings();
  }

  render() {
    return (
      <div className="goodgrowth-theme-styles" onMouseEnter={this.onComponentView}>
        <FooterWrapper className="footer">

          <div className="footer-elements">
            <div className="row">
              <div className="col-sm-12">
                <div className="row no-gutter">

                  <div className="col-sm-3">
                    <div className="footer-element">
                      <span className="typcn typcn-watch"></span>
                      <StyledDataParagraph>{companyData.FAKTUROMANIA_APP_COMPANY_WORKING_DAYS}<span>{companyData.FAKTUROMANIA_APP_COMPANY_WORKING_HOURS}</span></StyledDataParagraph>
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="footer-element">
                      <span className="typcn typcn-location-outline"></span>
                      <StyledDataParagraph>{companyData.FAKTUROMANIA_APP_COMPANY_STREET_SHORT}<span>{companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CODE} {companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CITY_SHORT}</span></StyledDataParagraph>
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="footer-element">
                      <span className="typcn typcn-mail"></span>
                      <StyledDataParagraph>E-MAIL:<span><a href="">{companyData.FAKTUROMANIA_APP_COMPANY_EMAIL}</a></span></StyledDataParagraph>
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="footer-element">
                      <span className="typcn typcn-phone-outline"></span>
                      <StyledDataParagraph>ZADZWOŃ:<span>{companyData.FAKTUROMANIA_APP_COMPANY_PHONE}</span></StyledDataParagraph>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-widgets">
            <div className="row">

              <div className="col-sm-3">
                <div className="footer-widget">
                  <h5>O NAS</h5>
                  <p>
                    Fakturomania to pełna księgowość online - aplikacja webowa, która nie
                    wymaga posiadania specjalistycznej wiedzy z zakresu rachunkowości i prawa.
                  </p>
                </div>
              </div>

              <div className="col-sm-3">
                <div className="footer-widget">
                  <h5>INFORMACJE</h5>
                  <ul className="posts">
                    <li><Link to={staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL} rel="nofollow">REGULAMIN SERWISU</Link></li>
                    <li><Link to={staticUrls.FAKTUROMANIA_COOKIES_PAGE_URL} rel="nofollow">POLITYKA COOKIES</Link></li>
                    <li><a href="#" role="button" onClick={this.onCookiePreferencesClick}>PREFERENCJE PLIKÓW COOKIES</a></li>
                    <li><Link to={staticUrls.FAKTUROMANIA_DOTACJE_PAGE_URL}>PROJEKT POIG 8.2</Link></li>
                  </ul>
                </div>
              </div>

              <div className="col-sm-3">
                <div className="footer-widget">
                  <h5>LINKI</h5>
                  <ul className="posts">
                    <li><Link to={staticUrls.FAKTUROMANIA_FUNKCJE_PAGE_URL}>FUNKCJE</Link></li>
                    <li><Link to={staticUrls.FAKTUROMANIA_CENNIK_PAGE_URL}>CENNIK</Link></li>
                    <li><Link to={staticUrls.FAKTUROMANIA_FAQ_PAGE_URL}>FAQ</Link></li>
                    <li><a href={staticUrls.FAKTUROMANIA_BAZA_WIEDZY_PAGE_URL} target="_blank">BAZA WIEDZY</a></li>
                    <li><Link to={staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL}>KONTAKT</Link></li>
                  </ul>
                </div>
              </div>

              <div className="col-sm-3">
                <div className="footer-widget">
                  <h5>DANE FIRMY</h5>
                  <p>{companyData.FAKTUROMANIA_APP_COMPANY_NAME}</p>
                  <p>{companyData.FAKTUROMANIA_APP_COMPANY_STREET_FULL}</p>
                  <p>{companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CODE} {companyData.FAKTUROMANIA_APP_COMPANY_POSTAL_CITY_FULL}</p>
                  <p>NIP: {companyData.FAKTUROMANIA_APP_COMPANY_NIP}</p>
                  <p>Kapitał zakładowy: {companyData.FAKTUROMANIA_APP_COMPANY_SHARE_CAPITAL}</p>
                  <br/>
                  <h5>POZNAJ NAS</h5>
                  <div className="materialize-theme-styles">
                    <ul className="social-link tt-animate ltr">
                      <li><a href={staticUrls.FAKTUROMANIA_FACEBOOK_PAGE_URL} target="_blank" rel="nofollow" onClick={this.onNavigateToSocialClick}><i className="fa fa-facebook"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </FooterWrapper>
      </div>
    )
  }

}

/** STYLES */

const FooterWrapper = styled.section`
  margin-top: 120px;
`;

const StyledDataParagraph = styled.p`
  text-transform: uppercase;
`;

export default Footer


// WEBPACK FOOTER //
// ./src/layouts/footer/footer.tsx